import React from 'react';
import styled, { css } from 'styled-components';

export const RaisedPanelContainer = styled.section`
  max-width: 720px; //849px
  margin-right: 20px;
  margin-bottom: 30px;
  background: #f3f4f6;
  box-sizing: border-box;
  border: 1px solid #dedede;
  border-radius: 5px;

  ${props =>
    props.embedded &&
    css`
      background: white;
      margin-top: 20px;
    `}
`;

export const OuterTriangle = styled.div`
  position: relative;
  left: 490px;
  top: -10px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #dedede;
  margin-bottom: -10px;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const InnerTriangle = styled.div`
  position: relative;
  left: -10px;
  top: 1px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
`;

function RaisedPanel(props) {
  return (
    <RaisedPanelContainer embedded={props.embedded}>
      {props.embedded ? (
        <OuterTriangle>
          <InnerTriangle />
        </OuterTriangle>
      ) : null}
      {props.children}
    </RaisedPanelContainer>
  );
}

export default RaisedPanel;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/RaisedPanel/raised-panel.jsx